module.exports = __webpack_public_path__ + "static/media/tr808_kick_01.05e519ee.wav";